export const enum ValueType {
  Boolean = 'boolean',
  File = 'file',
  Multiselect = 'multiselect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}
